import React from "react";


interface PointMarkerProps {
  type: string;
  onClick: () => void;
  onMouseOver: () => void;
  onMouseOut: () => void;
  title: string;
  isCategoryOrTagSelected: boolean;
  isActive: boolean;
}

const PointMarker: React.FC<PointMarkerProps> = ({ type, onClick, onMouseOver, onMouseOut, title, isCategoryOrTagSelected, isActive }) => {
  const iconSrc = `../../../images/icons/${type.toLowerCase()}.svg`;
  const size = isCategoryOrTagSelected ? 24 : 16;

  return (
    <img
      src={iconSrc}
      alt={title}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        position: "absolute",
        top: `-0px`,
        left: `-0px`,
        cursor: "pointer",
        pointerEvents: "auto",
        filter: isActive ? "drop-shadow(0px -1px 4px #FF9000) drop-shadow(0px -1px 4px #FF9000)" : "none",
        borderRadius: isActive ? '50%' : '0',
        zIndex: "4",
      }}
    />
  );
};

export default PointMarker;